import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import SchoolRoundedIcon from '@mui/icons-material/SchoolRounded';
import Typography from '@mui/material/Typography';
import ArticleRoundedIcon from '@mui/icons-material/ArticleRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import Avatar from "../images/AvatarMaker.svg";
import { CardActionArea } from '@mui/material';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import "../css/about.css";
import { Box } from '@mui/system';
export default function About(){
   return(
<div id='about'>
<Card sx={{ maxWidth: 345 }}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="140"
          image={Avatar}
          alt="Avatar"
        
        />
        <CardContent>
          <Typography gutterBottom variant="h5" component="div">
          Tarakeswar Mondal
          </Typography>
          <Typography variant="body2" color="text.secondary">
          I am Full Stack MERN developer
          </Typography>
          <br />
          <Box sx={{display:"flex"}}>
            <SchoolRoundedIcon />
         
          <Typography variant="body2" color="text.secondary">
         Jadavpur University,B.E.I.T [2020-24]
          </Typography>
          </Box>
          <br />
          <Box sx={{display:"flex"}}>
            <HomeRoundedIcon />
         
          <Typography variant="body2" color="text.secondary">
        West Bengal,India
          </Typography>
          </Box>
          <br />
          <Box sx={{display:"flex",columnGap:"3%"}}>
            <CheckCircleRoundedIcon style={{fill:"green"}} />
         
          <Typography variant="body2" color="text.secondary">
      NodeJS
          </Typography><CheckCircleRoundedIcon style={{fill:"green"}} />
         
         <Typography variant="body2" color="text.secondary">
         ReactJS
         </Typography>
         <CheckCircleRoundedIcon style={{fill:"green"}} />
         
         <Typography variant="body2" color="text.secondary">
        MongoDB
         </Typography>
          </Box>
          <br />
          <Box sx={{display:"flex",columnGap:"3%"}}>
            <CheckCircleRoundedIcon style={{fill:"green"}} />
         
          <Typography variant="body2" color="text.secondary">
            SQL
          </Typography><CheckCircleRoundedIcon style={{fill:"green"}} />
         
         <Typography variant="body2" color="text.secondary">
          REST API
         </Typography>
         <CheckCircleRoundedIcon style={{fill:"green"}} />
         
         <Typography variant="body2" color="text.secondary">
        Firebase
         </Typography>
          </Box>
          <br />
          <Box sx={{display:"flex",columnGap:"3%"}}>
            <ArticleRoundedIcon /><a href='https://www.geeksforgeeks.org/how-to-play-pause-video-or-audio-in-reactjs'  target="_blank" rel='noreferrer'>Toggle Audio Video in ReactJS</a>
          </Box>
        </CardContent>
      </CardActionArea>
    </Card>
    <div id='logosvg'>
    <Box sx={{display:"flex"}}>
    <img src='https://media-public.canva.com/6fP2U/MAEpy06fP2U/1/s.png' alt='svg' />
   
    <img src='https://media-public.canva.com/fF40I/MAE1mefF40I/1/s.png' alt='svg' />
    </Box>
    </div>
    <div id='about-background'>
    </div>
</div>
   );
}